import PropTypes from 'prop-types';
import checkSuccessUrl from './check-success.svg';

export const YouSuccessIcon = ({ size = 48, alt = '' }) => (
  <img
    src={checkSuccessUrl}
    alt={alt}
    width={size}
    height={size}
    data-testid="you-success-icon"
  />
);

YouSuccessIcon.propTypes = {
  size: PropTypes.number,
  alt: PropTypes.string,
};

export default YouSuccessIcon;
